import React from 'react'

import { SxProps } from '@mui/material'

import { useQuery } from 'utils/hooks'
import { useReportActions } from 'redux/actions/Reports'
import { useReport } from 'redux/hooks/Reports'
import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import DisabledWrapper from 'components_new/molecules/DisabledWrapper'
import EditableTitle from 'components_new/molecules/EditableTitle'
import RichTextEditor from 'components_new/molecules/RichTextEditor'

interface ReportHeaderProps {
  disabled?: boolean
  editMode: boolean
  id: string
  sx?: SxProps
}

const ReportHeader = (props: ReportHeaderProps) => {
  const { disabled, editMode, id, sx } = props

  const { query } = useQuery()
  const report = useReport(id)
  const { tryUpdateReport } = useReportActions()

  const { t } = useTranslation()

  if (!report) return null // $TODO

  return (
    <Box sx={sx}>
      <DisabledWrapper disabled={disabled}>
        <Box
          sx={{
            maxWidth: 'title'
          }}
        >
          <EditableTitle
            actions={true}
            autoFocus={Boolean(query['edit'])}
            disabled={!editMode}
            gutterBottom={true}
            onSubmit={(value) => tryUpdateReport(id, { title: value ?? '' })}
            placeholder={t('global', 'untitled')}
            sx={{ mb: 2 }}
            value={report.title}
            variant="h5"
          />
        </Box>

        {!editMode && !report.description ? null : (
          <RichTextEditor
            contentMaxWidth="content"
            placeholder={t('reports', 'description_placeholder')}
            edit={editMode}
            editHeight={96}
            onBlur={(value) => tryUpdateReport(id, { description: value })}
            paragraphVariant="subtitle2"
            value={report.description}
          />
        )}
      </DisabledWrapper>
    </Box>
  )
}

export default ReportHeader
